import styled from "styled-components";

export const StyledDeadlineBar = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[2]};
  border-radius: 0;
  font-size: ${({ theme }) => theme.fontSizes[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    flex-direction: row;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[1]};
  }
`;

export const Heading = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.white};
  font-size: inherit;
`;
